import { authMiddleware } from '@/router/middleware/authMiddleware'
import { roleMiddleware } from '@/router/middleware/roleMiddleware'
import RolesHelper from '@/helpers/Roles'
// import PublisherMenuConfig from '@/config/PublisherMenuConfig'

const publisher = [
    {
        path: '/publisher',
        // component: () => import('@/components/Layout/PublisherLayout.vue'),
        // props: {
        //     menu: PublisherMenuConfig,
        // },
        beforeEnter: [
            authMiddleware,
            roleMiddleware,
        ],
        meta: {
            authorize: [RolesHelper.Roles.Publisher],
        },
        children: [
            {
                path: 'dashboard',
                name: 'publisher-dashboard',
                component: () => import('@/views/Publisher/Dashboard.vue'),
            },
        ],
    },
]

export default publisher